import Globe from "react-globe.gl";
import { MeshLambertMaterial } from "https://esm.sh/three";
import { useRef, useEffect } from "react";
import "./customglobe.css";
import { calculateRotatedCoordinates, getRotatedPolygonsFeature, getRotatedCircularPolygonsFeature } from "../domain-utils";

function CustomGlobe({ domains, colors, activeDomainIndex }) {
    const globeRef = useRef();

    const polygonsData = [];
    const pointsData = [];

    domains.forEach((domain, index) => {
        const mat = new MeshLambertMaterial({ color: colors[index], opacity: index === activeDomainIndex ? 0.7 : 0.2, transparent: true });
        const backupMat = new MeshLambertMaterial({ color: colors[index - colors.length], opacity: 0.5, transparent: true });
        polygonsData.push(
            domain.icontools.region_type === 2 ?
                getRotatedCircularPolygonsFeature(
                    domain.icontools.center_lat,
                    domain.icontools.center_lon,
                    domain.icontools.radius,
                    index === activeDomainIndex ? (domains.length + 1) * 0.004 : 0.004 * (index + 1),
                    index <= colors.length - 1 ? mat : backupMat,
                    index <= colors.length - 1 ? colors[index] : colors[index - colors.length],
                ) :
                getRotatedPolygonsFeature(
                    domain.icontools.center_lat,
                    domain.icontools.center_lon,
                    domain.icontools.hwidth_lat,
                    domain.icontools.hwidth_lon,
                    domain.icontools.pole_lat,
                    domain.icontools.pole_lon,
                    index === activeDomainIndex ? (domains.length + 1) * 0.004 : 0.004 * (index + 1),
                    index <= colors.length - 1 ? mat : backupMat,
                    index <= colors.length - 1 ? colors[index] : colors[index - colors.length],
                )
        );
        pointsData.push({
            lng: domain.icontools.pole_lon ?? -180,
            lat: domain.icontools.pole_lat ?? 90,
            color: index <= colors.length - 1 ? colors[index] : colors[index - colors.length],
        });
    });

    useEffect(() => {
        if (domains[activeDomainIndex]?.icontools.region_type !== 1) {
            let lon = domains[activeDomainIndex]?.icontools.center_lon || 0;

            let lat = domains[activeDomainIndex]?.icontools.center_lat || 0;

            if (domains[activeDomainIndex].icontools.lrotate) {
                const calculateCoords = calculateRotatedCoordinates(
                    domains[activeDomainIndex]?.icontools.center_lat,
                    domains[activeDomainIndex]?.icontools.center_lon,
                    domains[activeDomainIndex]?.icontools.pole_lat,
                    domains[activeDomainIndex]?.icontools.pole_lon,
                    true
                );

                lon = calculateCoords.lonRot
                lat = calculateCoords.latRot
            }

            globeRef.current.pointOfView({
                lng: lon,
                lat: lat,
            });
        }

    }, [domains, activeDomainIndex]);

    return (
        <div className={"globe-wrapper"}>
            <Globe
                ref={globeRef}
                globeTileEngineUrl={(x, y, l) => `https://tile.openstreetmap.org/${l}/${x}/${y}.png`}
                enablePointerInteraction={false}

                polygonsData={polygonsData}
                polygonSideColor={"color"}
                polygonCapMaterial={"material"}
                polygonStrokeColor={() => '#111'}
                polygonAltitude={"altitude"}

                pointsData={pointsData}
                pointColor={"color"}
            />
            <p className={"osm-attribution"}>
                <a href="https://github.com/vasturiano/react-globe.gl">react-globe.gl</a> |
                &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors
            </p>
        </div>
    );
}

export default CustomGlobe;
